import * as React from 'react';

import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import 'minireset.css';
import { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import mediaQueries from 'src/constants/responsive';
import { bodyFontSize, mainColor, secondaryColor } from 'src/constants/stylesheet';
import useRouter from 'use-react-router';
import { useApi } from '../@context/Api';
import fonts from '../constants/fonts';
import spacing from '../constants/spacing';
import { Language } from '../utils/Languages';

export type MenuProps = {};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 20,
      transition: 'transform .4s ease',

      backgroundColor: 'white',
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        paddingLeft: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        paddingRight: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        height: spacing.MenuHeight.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        paddingRight: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        height: spacing.MenuHeight.Tablet,
      },
      [mediaQueries.AfterTablet]: {
        height: spacing.MenuHeight.Desktop,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
        paddingRight: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
        paddingRight: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
        paddingRight: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
      },
    },
    hide: {
      transform: 'translateY(-100%)'
    },
    rootInner: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    logo: {
      [mediaQueries.Mobile]: {
        flex: `1 1 ${1 / 3 * 100}%`,

        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        flex: `1 1 ${1 / 3 * 100}%`,

        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        flex: `1 1 ${1 / 3 * 100}%`,

        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        flex: `1 1 ${1 / 3 * 100}%`,

        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        flex: `1 1 ${2 / 4 * 100}%`,

        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
      }
    },
    logoLink: {
      ...fonts.NeueHaasGroteskBold,
      [mediaQueries.Mobile]: {
        fontSize: `${18 / bodyFontSize.Mobile}rem`,
      },
      [mediaQueries.AfterMobile]: {
        fontSize: '1rem',
      },
    },
    nav: {
      display: 'flex',

      [mediaQueries.Mobile]: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        height: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'height .5s cubic-bezier(0.52, 0.16, 0.24, 1)',
        paddingLeft: spacing.GutterGrid.Mobile,
        paddingRight: spacing.GutterGrid.Mobile,
        backgroundColor: 'white',

        '$isOpen &': {
          height: '100vh'
        },
      },
      [mediaQueries.Tablet]: {
        flex: `1 1 ${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        flex: `1 1 ${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        flex: `1 1 ${2 / 3 * 100}%`,
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        flex: `1 1 ${2 / 4 * 100}%`,
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
      },
    },
    navLink: {
      ...fonts.NeueHaasGroteskBold,
      marginRight: 20,
      color: secondaryColor,
      '&:hover': {
        color: mainColor
      },
      [mediaQueries.Mobile]: {
        fontSize: `${32 / bodyFontSize.Mobile}rem`,
        lineHeight: '1em',
        paddingBottom: 5,

        '&:first-child': {
          marginTop: '8vw'
        }
      },
      [mediaQueries.AfterMobile]: {
        fontSize: '1rem',
      },
    },
    active: {
      color: mainColor
    },
    switchLang: {
      ...fonts.NeueHaasGroteskBold,
      color: secondaryColor,
      '&:hover': {
        color: mainColor
      },

      [mediaQueries.Mobile]: {
        fontSize: `${32 / bodyFontSize.Mobile}rem`,
        lineHeight: '1em',
        paddingBottom: 5
      },
      [mediaQueries.AfterMobile]: {
        fontSize: '1rem',
        marginLeft: 'auto',
      },
    },
    isOpen: {},
    burguerLink: {
      position: 'relative',
      width: 25,
      height: 20,
      display: 'none',

      [mediaQueries.Mobile]: {
        display: 'block',
        marginLeft: spacing.GutterGrid.Mobile / 2,
        marginRight: spacing.GutterGrid.Mobile / 2,
      },
    },
    burguerLogo: {
      display: 'block',
      position: 'absolute',
      left: 0,
      right: 0,
      backgroundColor: '#000',
      height: 2,
      top: 6,
      transition: 'background 0.2s',

      '&:before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        left: 0,
        width: '100%',
        backgroundColor: '#000',
        height: 2,
        top: '-6px',

        transitionDuration: '0.2s, 0.2s',

        transitionProperty: 'top, transform',

        transitionDelay: '0.2s, 0s',

        transitionTimingFunction: 'cubic-bezier(0.04, 0.04, 0.12, 0.96)',
      },

      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        left: 0,
        width: '100%',
        backgroundColor: '#000',
        height: 2,
        bottom: '-6px',

        transitionDuration: '0.2s, 0.2s',
        transitionProperty: 'bottom, transform',
        transitionDelay: '0.2s, 0s',
        transitionTimingFunction: 'cubic-bezier(0.04, 0.04, 0.12, 0.96)',
      },

      '$isOpen &': {
        backgroundColor: 'transparent',
      },

      '$isOpen &:before': {
        top: 0,
        transform: 'rotate(45deg)',
        transitionDelay: '0s, 0.2s',
      },

      '$isOpen &:after': {
        bottom: 0,
        transform: 'rotate(-45deg)',
        transitionDelay: '0s, 0.2s',
      }

    },

  }));

const Menu: React.FC<MenuProps> = () => {
  const cls = useStyles();
  const { app } = useApi();
  const { location: { pathname } } = useRouter();
  const [opened, setOpened] = useState(false);
  const header = useRef<HTMLHeadElement>(null);

  const onClick = () => {
    setOpened(!opened);
  }

  const lastScrollTop = useRef(0);
  const delta = 5;
  useEffect(
    () => {
      const { clientHeight } = header.current!;
      const scrollingContainer = document.getElementById('scrollContainer');

      if (!scrollingContainer) { return; }

      const onScroll = () => {
        const scrollTop = scrollingContainer.scrollTop + document.body.scrollTop;

        if (Math.abs(lastScrollTop.current - scrollTop) <= delta) {
          return;
        }

        if (header.current!.classList.contains(cls.isOpen)) { return; }

        if (scrollTop > lastScrollTop.current && scrollTop > clientHeight) {
          // Scroll Down
          header.current!.classList.add(cls.hide);

        } else {
          // Scroll Up
          header.current!.classList.remove(cls.hide);
        }

        lastScrollTop.current = scrollTop;
      }
      scrollingContainer.addEventListener('scroll', onScroll);
      return () => {
        scrollingContainer.removeEventListener('scroll', onScroll);
      };
    },
    [cls.hide]
  );

  const isHome = pathname === '/en' || pathname === '/fr'
  const editionLink = (menu: IPageDto) => {
    const m = menu as EditionsDto;
    return m.Link;
  }

  const handleExhibitionsClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    const elt = document.getElementById(id);

    if (elt) {
      elt.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header ref={header} className={classNames(cls.root, opened && cls.isOpen)}>
      <div className={cls.rootInner}>
        <div className={cls.logo}>
          <Link to={`/${Language}`} className={cls.logoLink}>RABOUAN MOUSSION</Link>
        </div>
        <nav className={cls.nav}>
          {app && app.Menus.map(menu => {
            switch (menu.type) {
              case 'Editions':
                const m = menu as EditionsDto;
                return <a
                  key={m.UID}
                  href={m.Link}
                  target="_blank"
                  className={cls.navLink}
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => {
                    if (opened) {
                      setOpened(false);
                    }
                  }}
                >
                  {menu.Title}
                </a>;

              case 'Exhibitions':
                return isHome ? <a
                  key={menu.UID}
                  className={cls.navLink}
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={event => {
                    handleExhibitionsClick(event, menu.UID)
                    if (opened) {
                      setOpened(false);
                    }
                  }}
                >
                  {menu.Title}
                </a> :
                  <NavLink
                    key={menu.UID}
                    to={`/${Language}?${menu.UID}`}
                    className={classNames(cls.navLink, pathname.split('/')[2] === menu.UID && cls.active)}
                    activeClassName={cls.active}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClick={() => {
                      if (opened) {
                        setOpened(false);
                      }
                    }}
                  >
                    {menu.Title}
                  </NavLink>;

              default:
                return <NavLink
                  key={menu.UID}
                  to={menu.type === 'Editions' ? editionLink(menu) : `/${Language}/${menu.UID}`}
                  className={cls.navLink}
                  activeClassName={cls.active}
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => {
                    if (opened) {
                      setOpened(false);
                    }
                  }}
                >
                  {menu.Title}
                </NavLink>;

            }
          })}
          <a
            href={Language === "en" ? '?switch-lang=fr' : '?switch-lang=en'}
            className={cls.switchLang}
          >
            {Language === "en" ? "Français" : "English"}
          </a>
        </nav>
        <a className={cls.burguerLink} onClick={onClick}>
          <span className={cls.burguerLogo} />
        </a>
      </div>
    </header>
  );
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu.tsx